import { render, staticRenderFns } from "./UpdateEditCard.vue?vue&type=template&id=570d0a73&"
import script from "./UpdateEditCard.vue?vue&type=script&lang=ts&"
export * from "./UpdateEditCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports